import React from 'react'
import { SubHeading } from '../../components'

import { images } from '../../constants'
import './Header.css'

const Header = () => (
  <div className="app__header app__wrapper section__padding" id="home">
    <div className="app__wrapper_info">
      <SubHeading title="Chase the new flavour" />
      <h1 className="app__header-h1">The key to Fine Dining</h1>
      <p className="p__opensans" style={{ margin: '2rem 0' }}>
        Sit tellus lobortis sed senectus vivamus molestie. Condimentum volutpat
        morbi facilisis quam scelerisque sapien. Et, penatibus aliquam amet
        tellus
      </p>
      <button type="button" className="custom__button">
        Explore Menu
      </button>
    </div>

    <div className="app__wrapper_img">
      <picture>
        {/* Si la pantalla es de menos de 768px, carga la versión pequeña */}
        <source
          media="(max-width: 767px)"
          srcSet={
            images.welcome_mobile
          } /* Una versión de la imagen de 350px de ancho */
        />
        {/* Por defecto (Escritorio), carga la original */}
        <img
          src={images.welcome}
          alt="header img"
          width="451"
          height="497"
          fetchpriority="high"
        />
      </picture>
    </div>
  </div>
)

export default Header
